import { render, staticRenderFns } from "./CalculatePriceComponent.vue?vue&type=template&id=f8cc9d32&scoped=true&"
import script from "./CalculatePriceComponent.vue?vue&type=script&lang=js&"
export * from "./CalculatePriceComponent.vue?vue&type=script&lang=js&"
import style0 from "./CalculatePriceComponent.vue?vue&type=style&index=0&id=f8cc9d32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8cc9d32",
  null
  
)

export default component.exports